import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { XInput } from '@swordhealth/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordInput',
  props: {
    value: {},
    type: {},
    validation: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

/**
 * Bridge component: wraps XInput with Vue 2 v-model compat and vee-validate defaults.
 *
 * Purpose:
 * - Adapts Vue 2 v-model (value/input) to Vue 3 XInput (modelValue/update:modelValue)
 * - Enables vee-validate integration on all input fields for Zod-based validation
 * - Required while using @vue/compat in MODE: 2
 *
 * Once compat is removed or MODE is set to 3 globally, evaluate if direct XInput mapping
 * in global-components.ts is sufficient or if vee-validate defaults should be preserved.
 */
const props = __props

const emit = __emit

function handleUpdate(newValue: string | number | boolean | object) {
  props.validation?.$touch()
  emit('input', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XInput), _mergeProps(_ctx.$attrs, {
    type: __props.type,
    "model-value": __props.value,
    "validation-triggers": { onBlur: true, onChange: true, onInput: true },
    "onUpdate:modelValue": handleUpdate
  }), null, 16, ["type", "model-value"]))
}
}

})